import FiltersEditor from './filtersEditor';

export default FiltersEditor;
